import { render } from "./DriveDesktopAllFiles.vue?vue&type=template&id=48e66520&scoped=true&ts=true"
import script from "./DriveDesktopAllFiles.vue?vue&type=script&lang=ts"
export * from "./DriveDesktopAllFiles.vue?vue&type=script&lang=ts"

import "./DriveDesktopAllFiles.vue?vue&type=style&index=0&id=48e66520&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e66520"]])

export default __exports__